import { TableCell, TableRow, Spinner } from '@client/toolkit';
import { InputCell } from '../InputCell/input-cell';
import Chip from '@mui/material/Chip';
import { colors } from '../../../../../styles/color-tokens';
import { toNumberString, toCurrencyString } from '@client/toolkit';
import { PercentChange } from '../PercentageChange/percentage-change';
import { useTranslation } from 'react-i18next';
import { NetYieldBuildingDetailReadModel } from '@client/api';
import { useBuildingFinancials } from '../../../../../hooks/useBuildingFinancials';
import { useDashboardFilters } from '../../../context/dashboard-filters.context';

export const BuildingYieldRow = (props: NetYieldBuildingDetailReadModel) => {
  const { t } = useTranslation('widget');

  const { selectedDateFrom, selectedDateTo } = useDashboardFilters();

  const { buildingDetail, operatingCost, setOperatingCost, propertyValue, setPropertyValue, isLoading, isFetching, handleSaveFinancials } =
    useBuildingFinancials(props, selectedDateFrom, selectedDateTo);

  return (
    <TableRow key={buildingDetail.spaceId} className="align-middle">
      <TableCell size="small" className="px-3">
        {buildingDetail.name}
      </TableCell>
      <InputCell
        value={operatingCost}
        onChange={setOperatingCost}
        onBlur={handleSaveFinancials}
        placeholder={t('buildingNetYield.placeholder')}
        disabled={isLoading || isFetching}
      />
      <TableCell size="small" align="right" className="px-4">
        {toCurrencyString(buildingDetail.netIncomeAmount?.amount, '-', { currency: 'NOK', })}
      </TableCell>
      <TableCell size="small" align="right" className="px-4">
        {isLoading || isFetching ? (
          <Spinner size="sm" className="ml-auto" />
        ) : (
          buildingDetail.costPerM2 && toCurrencyString(buildingDetail.costPerM2, '-', { currency: 'NOK' })
        )}
      </TableCell>
      <InputCell
        value={propertyValue}
        onChange={setPropertyValue}
        onBlur={handleSaveFinancials}
        placeholder={t('buildingNetYield.placeholder')}
        disabled={isLoading || isFetching}
      />
      <TableCell size="small" align="right" className="px-4">
        {isLoading || isFetching ? (
          <Spinner size="sm" className="ml-auto" />
        ) : buildingDetail.netYield != null ? (
          `${toNumberString(buildingDetail.netYield)}%`
        ) : (
          '-'
        )}
      </TableCell>
      <TableCell size="small" align="right">
        {isLoading || isFetching ? (
          <Spinner size="sm" className="ml-auto" />
        ) : buildingDetail.percentChange != null ? (
          <PercentChange value={buildingDetail.percentChange} />
        ) : (
          <Chip
            label={t('buildingNetYield.noData')}
            size="small"
            sx={{ backgroundColor: colors.status.error, fontSize: '0.75rem', borderRadius: '0.4rem' }}
          />
        )}
      </TableCell>
    </TableRow>
  );
};
